import React from 'react'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    color: `${theme.palette.secondary.main} !important`,
    textDecoration: 'none!important',
  },
}))

const PrimaryRouterLink = ({ children, ...props }) => {
  const classes = useStyles()
  return (
    <Link
      {...props}
      className={clsx(classes.root, props.className, 'cursor-pointer')}
    >
      {children}
    </Link>
  )
}

export default PrimaryRouterLink
